import moment from "moment";

export const serverStatusStyles = {
  online: { label: "Online", dot: "bg-green-500", badge: "bg-green-100 text-green-700" },
  degraded: { label: "Degraded", dot: "bg-amber-500", badge: "bg-amber-100 text-amber-700" },
  unhealthy: { label: "Unhealthy", dot: "bg-red-500", badge: "bg-red-100 text-red-700" },
  crashed: { label: "Crashed", dot: "bg-red-600", badge: "bg-red-600 text-white" },
  unknown: { label: "Unknown", dot: "bg-gray-400", badge: "bg-gray-100 text-gray-600" },
};

export const incidentStatusStyles = {
  crashed: { label: "Crashed", badge: "bg-red-100 text-red-700" },
  recovered: { label: "Recovered", badge: "bg-green-100 text-green-700" },
};

export const confidenceStyles = {
  exact: { label: "Exact", badge: "bg-blue-100 text-blue-700" },
  suspected: { label: "Suspected", badge: "bg-amber-100 text-amber-700" },
  unknown: { label: "Unknown", badge: "bg-gray-100 text-gray-600" },
};

export const formatPercent = (value) => (value === null || value === undefined ? "—" : `${Math.round(value * 10) / 10}%`);

export const formatDateTime = (date, format = "MMM D, YYYY h:mm:ss A") => (date ? moment(date).format(format) : "—");

export const formatRelative = (date) => {
  if (!date) return "Never";
  const seconds = moment().diff(moment(date), "seconds");
  if (seconds < 45) return "Just now";
  return moment(date).fromNow();
};

export const formatDuration = (seconds, isUpperBound = false) => {
  if (seconds === null || seconds === undefined) return "—";
  const total = Math.max(0, Math.round(seconds));
  const hours = Math.floor(total / 3600);
  const minutes = Math.floor((total % 3600) / 60);
  const secs = total % 60;
  let text = `${secs}s`;
  if (hours > 0) text = `${hours}h ${String(minutes).padStart(2, "0")}m ${String(secs).padStart(2, "0")}s`;
  else if (minutes > 0) text = `${minutes}m ${String(secs).padStart(2, "0")}s`;
  return isUpperBound ? `≤ ${text}` : text;
};

// eslint-disable-next-line no-control-regex
export const stripAnsi = (text) => String(text || "").replace(/\u001b\[[0-9;?]*[ -/]*[@-~]/g, "");

export const formatBytes = (bytes) => {
  if (!bytes) return "0 B";
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;
  return `${(bytes / (1024 * 1024)).toFixed(2)} MB`;
};
